<template>
  <div class="flex flex-wrap">
    <TimeTrackingButton class="mr-2" title="U Burgstraße" :bigButton="false" @onButtonClick="onBurgstrasseClick" />
    <TimeTrackingButton title="S Hammerbrook Süd" :bigButton="false" @onButtonClick="onHammerbrookClick" />
  </div>
  <div v-if="station == 'burgstrasse'">
    <div class="text-left">
      Station: Burgstraße
    </div>
    <div class="text-left">
      {{ stationBurgstrasseData.data.time.date }} {{ stationBurgstrasseData.data.time.time }}
    </div>
    <hr>

    <template v-for="departure in stationBurgstrasseData.data.departures"  :key="departure.serviceId">
      <HvvDepartures :departure="departure" :time="timeToInt"/>
      <hr>
    </template>
  </div>
  <div v-if="station == 'hammerbrook'">
    <div class="text-left">
      Station: S Hammerbrook Süd
    </div>
    <div class="text-left">
      {{ stationHammerbrookData.data.time.date }} {{ stationHammerbrookData.data.time.time }}
    </div>
    <hr>

    <template v-for="departure in stationHammerbrookData.data.departures"  :key="departure.serviceId">
      <HvvDepartures :departure="departure" :time="timeToInt"/>
      <hr>
    </template>
  </div>

  <hr>
  <pre v-if="false" class="text-left">{{ stationBurgstrasseData.data.departures }}</pre>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import TimeTrackingButton from "./guiComponents/TimeTrackingButton.vue"
import HvvDepartures from "./HvvDepartures.vue"

export default {
  name: "HvvStations",
  components: {
    TimeTrackingButton,
    HvvDepartures,
  },
  data() {
    return {
      station: '',
    }
  },
  computed: {
    ...mapGetters("stations", {
      stationBurgstrasseData: "stationBurgstrasseData",
      stationHammerbrookData: "stationHammerbrookData",
    }),
    timeToInt() {
      let timeSplit = []
      if (this.station == 'burgstrasse') {
        timeSplit = this.stationBurgstrasseData.data.time.time.split(':')
      }
      if (this.station == 'hammerbrook') {
        timeSplit = this.stationHammerbrookData.data.time.time.split(':')
      }
      if (timeSplit.length == 2) {
        return parseInt(timeSplit[0] * 60 + parseInt(timeSplit[1]))
      }
      return 0
    },
  },
  created() { },
  methods: {
    ...mapActions("stations", {
      getBurgstrasse: "getBurgstrasse",
      getHammerbrook: "getHammerbrook",
    }),
    onBurgstrasseClick() {
      this.station = "burgstrasse"
      this.getBurgstrasse()
    },
    onHammerbrookClick() {
      this.station = "hammerbrook"
      this.getHammerbrook()
    },
  },
}
</script>
